import React from 'react';
import Home from '@component/gridgio/project/home';
import PageTemplate from '@page/gridgio/page-template';
import * as color from '@constant/color';

const HEADER_TITLE = '프로젝트';

const HomePage: React.FC = () => (
  <PageTemplate customHeader='none' title={HEADER_TITLE} mode='page' backgroundColor={color.GRAY_BACKGROUND_COLOR}>
    <Home />
  </PageTemplate>
);

export default HomePage;
